import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { toggleClass } from '@opten/dom/toggle-class';
import { hasClass } from '@opten/dom/has-class';
import { getOrSetRandomId } from '@opten/dom/get-or-set-random-id';


import { LoadingIndicator } from './../loading-indicator/loading-indicator';
import { Component } from '@opten/compiler/metadata/component';
import { getStickyOffset } from '../../utilities/scroll-helper';
import { scrollToOffset } from '@opten/scroll/scroll-to-offset';
import { linearTween } from '@opten/animation/linear-tween';
import { queryStringAsObject } from '@opten/url/query-string-as-object';


class MakeModel {
	make: string;
	value: string;
	prefixValue: string;
	element: HTMLOptionElement;
	isVisible: boolean;
	isChooseMake: boolean;
}

class MakesModels {
	filterMakesElement: HTMLSelectElement;
	filterModelsElement: HTMLSelectElement;
	filterMakeModels: MakeModel[] = [];
	wrapperElement: HTMLElement;
	wrapperId: string;
	id: number;
}


@Component({ className: 'js-vehicles-storage' })
export class VehiclesStorageComponent {

	loadingIndicator: string;
	filterContentElement: HTMLElement;
	resultsContentElement: HTMLElement;
	formElementWrapper: HTMLElement;

	targetFilterToLoad: string;
	targetFilterResetToLoad: string;
	targetResultsToLoad: string;
	targetGetCountResults: string;

	language: string;
	formElement: HTMLFormElement;
	formPageElement: HTMLInputElement;
	formPageSearchElement: HTMLElement;
	formPageSearchElementTextCount: string;
	formPageSearchElementText: string;


	filterMakesModelsWrapper: MakesModels[] = [];
	filterFormData: string;

	isInitialLoad = true;
	vehicleLinkElement: HTMLElement;
	formPageSearchContainerElement: HTMLElement;
	formPageSearchContainerWrapperElement: HTMLElement;
	formPageFiltersElement: HTMLElement;
	filterMakesModelsTypeNameTemplate: HTMLElement;
	filterMakesModelsTypeNameWrapper: HTMLElement;
	filterMakesModelsTypeName: HTMLElement;
	filterMakesModelsTypeNameMaxCount: number;
	filterMakesModelsTypeNameAdd: HTMLElement;

	hiddenClass = 'd-none';
	stickyClass = 'is-sticky';

	constructor(private element: HTMLElement) {
		this.loadingIndicator = new LoadingIndicator().contentLoading;
		this.filterContentElement = element.getElementsByClassName('js-vehicles-storage__filter')[0] as HTMLElement;
		this.resultsContentElement = element.getElementsByClassName('js-vehicles-storage__results')[0] as HTMLElement;

		this.init();
	}

	init() {
		this.targetFilterToLoad = this.filterContentElement.getAttribute('data-load');
		this.targetFilterResetToLoad = this.filterContentElement.getAttribute('data-reset-load');
		this.targetResultsToLoad = this.filterContentElement.getAttribute('data-results-load');
		this.targetGetCountResults = this.filterContentElement.getAttribute('data-results-count-load');
		var dataLanguage = document.body.getAttribute('data-language-long');
		if (dataLanguage && dataLanguage.length > 0) {
			this.language = dataLanguage;
		}
		this.handleLoadFilterContent();
	}

	private handleLoadFilterContent(doResetFilter: boolean = false, loadVehicleModel: boolean = false): void {
		this.filterContentElement.innerHTML = this.loadingIndicator;
		let target = this.targetFilterToLoad;
		if (doResetFilter) {
			target = this.targetFilterResetToLoad;
			if (loadVehicleModel && this.vehicleLinkElement) {
				let vehicleModel = this.vehicleLinkElement.getAttribute('href');
				if (vehicleModel != null && vehicleModel.length > 0) {
					vehicleModel = vehicleModel.replace('?', '');
					target += "&" + vehicleModel;
				}
			}
		}
		fetch(target, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'accept-language': this.language,
				// todo: why? if we change to a api controller we don't have this problem...
				'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
			},
			credentials: 'include'
		})
			.then(response => {
				const contentType = response.headers.get('content-type');
				if (contentType && contentType.includes('text/html')) {
					return response.text();
				}
			})
			.then(data => {
				this.handleDataContentFilterResult(data, doResetFilter);
			});
	}

	private handleDataContentFilterResult(data: string, doResetFilter: boolean = false) {
		if (data != null && data.length > 0) {
			this.filterContentElement.innerHTML = data;
			const formElementWrappers = this.filterContentElement.getElementsByClassName('js-vehicles-storage__filter__form');
			if (formElementWrappers && formElementWrappers.length > 0) {
				this.formElementWrapper = formElementWrappers[0] as HTMLElement;
				this.initializeFilterForm(doResetFilter);
				this.handleLoadResultsFromFilterForm();
			}
		}
	}

	private handleSubmitFilterForm(event: Event) {
		event.preventDefault();
		this.handleLoadResultsFromFilterForm();
	}

	private handleLoadResultsFromFilterForm(resetPageToDefault = true) {
		if(resetPageToDefault && this.formPageElement){
			this.formPageElement.value = "1";
		}
		if ($(this.formElement).valid()) {
			this.filterFormData = $(this.formElement).serialize();

			this.setFilterQuery(this.filterFormData);
			if (this.isInitialLoad == false) {
				const rect = this.resultsContentElement.getBoundingClientRect();

				scrollToOffset(
					rect.top,
					linearTween,
					150,
					(getStickyOffset() * -1) - 150
				);
			}

			this.isInitialLoad = false;
			this.resultsContentElement.innerHTML = this.loadingIndicator;

			fetch(this.targetResultsToLoad, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'accept-language': this.language,
					// todo: why? if we change to a api controller we don't have this problem...
					'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
				},
				body: this.filterFormData,
				credentials: 'include'
			})
				.then(response => {
					const contentType = response.headers.get('content-type');
					if (contentType && contentType.includes('text/html')) {
						return response.text();
					}
				})
				.then(data => {
					this.handleDataFormResult(data);
				});
		}
	}

	private setFilterQuery(formData: string) {
		if (this.isInitialLoad == false) {
			let newUrl = window.location.href.replace(window.location.search, '');
			if (formData) {
				newUrl += '?' + formData;
			}
			history.pushState(null, document.title, newUrl);
		}
	}

	private handleDataFormResult(data: string) {
		if (data != null && data.length > 0) {
			this.resultsContentElement.innerHTML = data;
			if (this.isInitialLoad == false && window.location.href.indexOf('?') > -1) {
				const rect = this.resultsContentElement.getBoundingClientRect();

				scrollToOffset(
					rect.top,
					linearTween,
					150,
					(getStickyOffset() * -1) - 150
				);
			}
			const pageBackButtons = Array.from(this.resultsContentElement.getElementsByClassName('js-page-back'));
			const pageNextButtons = Array.from(this.resultsContentElement.getElementsByClassName('js-page-next'));
			const pageJumpButtons = Array.from(this.resultsContentElement.getElementsByClassName('js-page-jump'));
			if (pageBackButtons) {
				pageBackButtons.forEach(o => o.addEventListener('click', (e) => this.loadPreviousPage(e)));
			}
			if (pageNextButtons) {
				pageNextButtons.forEach(o => o.addEventListener('click', (e) => this.loadNextPage(e)));
			}
			if (pageJumpButtons) {
				pageJumpButtons.forEach(o => o.addEventListener('click', (e) => this.loadJumpPage(e)));
			}

			const resultsCountElement = this.resultsContentElement.getElementsByClassName('js-vehicles-storage__results__count');
			const resultsCountData = resultsCountElement && resultsCountElement != undefined && resultsCountElement.length > 0 ? parseInt((resultsCountElement[0] as HTMLElement).innerText,10).toString() : '0';
			this.updateFilterFormSearchCountText(resultsCountData);
		}
	}

	private initializeFilterForm(doResetFilter: boolean = false) {
		if (this.formElementWrapper) {
			const formElements = this.formElementWrapper.getElementsByTagName('form');
			if (formElements && formElements.length > 0) {
				this.formElement = formElements[0];
				this.formElement.addEventListener('submit', (e) => this.handleSubmitFilterForm(e));
				if (doResetFilter) {
					if ($(this.formElement).valid()) {
						let formData = $(this.formElement).serialize();
						this.setFilterQuery(formData);
					}
				}

				this.formPageElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__page')[0] as HTMLInputElement;
				const sortFormElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__sort')[0] as HTMLInputElement;
				if (sortFormElement) {
					sortFormElement.addEventListener('change', () => this.handleLoadResultsFromFilterForm());
				}
				this.formPageSearchElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__search')[0] as HTMLElement;
				if (this.formPageSearchElement) {
					this.formPageSearchElementText = this.formPageSearchElement.innerText;
					this.formPageSearchElementTextCount = this.formPageSearchElement.getAttribute('data-count-text');
					this.initializeFilterFormObservation();
				}

				this.formPageFiltersElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__filters')[0] as HTMLElement;
				this.formPageSearchContainerElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__search__container')[0] as HTMLElement;
				this.formPageSearchContainerWrapperElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__search__container__wrapper')[0] as HTMLElement;

				if (this.formPageSearchContainerElement && this.formPageSearchContainerWrapperElement && this.formPageFiltersElement) {

					this.initializeFilterFormSearchContainerSticky();
				}

				const resetFormElement = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__reset')[0] as HTMLInputElement;
				if (resetFormElement) {
					resetFormElement.addEventListener('click', (e) => this.resetFilter(e));
				}

				const vehicleLinkElements = document.getElementsByClassName('js-vehicles-storage__filter__vehicle');
				if (vehicleLinkElements && vehicleLinkElements.length > 0) {
					this.vehicleLinkElement = vehicleLinkElements[0] as HTMLElement;
					this.vehicleLinkElement.addEventListener('click', (e) => this.resetFilter(e, true));
				}
				this.initializeFilterFormMakesModelsTypeNameSection();
				$.validator.unobtrusive.parse('form');
				this.updateModelsFromQueryIfNotSet();
			}
		}
	}

	private initializeFilterFormMakesModelsTypeNameSection() {
		this.filterMakesModelsTypeNameWrapper = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__filters__makes-models-typename__wrapper')[0] as HTMLElement;
		if (this.filterMakesModelsTypeNameWrapper) {
			this.filterMakesModelsWrapper = [];
			this.filterMakesModelsTypeName = this.filterMakesModelsTypeNameWrapper.getElementsByClassName('js-vehicles-storage__filter__form__filters__makes-models-typename')[0] as HTMLElement;
			if (this.filterMakesModelsTypeName) {
				this.filterMakesModelsTypeNameMaxCount = parseInt(this.filterMakesModelsTypeName.getAttribute('data-max-count'), 10);

				const filterMakesModelsTypeNames = Array.from(this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__filters__makes-models-typename--single')) as HTMLElement[];
				if (filterMakesModelsTypeNames && filterMakesModelsTypeNames.length > 0) {
					let i = 0;
					filterMakesModelsTypeNames.forEach(o => this.initializeFilterFormMakesModelsTypeName(o, i++));
				}
			}
			this.filterMakesModelsTypeNameAdd = this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__filters__makes-models-typename__add')[0] as HTMLElement;
			this.filterMakesModelsTypeNameTemplate = document.getElementById('js-vehicles-storage__filter__form__filters__makes-models-typename-template');
			if (this.filterMakesModelsTypeNameAdd && this.filterMakesModelsTypeNameTemplate) {
				this.filterMakesModelsTypeNameAdd.addEventListener('click', (e) => this.handleFilterMakesModelsTypeNameAdd(e));
			}
		}
	}

	private initializeFilterFormMakesModelsTypeName(wrapperElement: HTMLElement, id: number) {
		const wrapperId = getOrSetRandomId(wrapperElement);
		const filterMakeModels: MakeModel[] = [];
		const filterModelsElement = wrapperElement.getElementsByClassName('js-vehicles-storage__filter__form__models')[0] as HTMLSelectElement;
		if (filterModelsElement) {
			if (filterModelsElement.options.length > 0) {
				for (let i = 0; i < filterModelsElement.options.length; i++) {
					let option = filterModelsElement.options[i];
					const value = option.value;
					if (value && value.length > 0) {
						filterMakeModels.push({
							make: value.split('-')[0],
							value: value,
							prefixValue: value.indexOf('%') > -1 ? value.substring(0, value.indexOf('%')) : value,
							element: option,
							isVisible: option.selected,
							isChooseMake: value == "choose-make"
						});
					}
				}
			}
		}
		const filterMakesElement = wrapperElement.getElementsByClassName('js-vehicles-storage__filter__form__makes')[0] as HTMLSelectElement;
		if (filterModelsElement && filterMakeModels.length > 0 && filterMakesElement) {
			this.filterMakesModelsWrapper.push({
				filterMakesElement: filterMakesElement,
				filterModelsElement: filterModelsElement,
				filterMakeModels: filterMakeModels,
				wrapperElement: wrapperElement,
				wrapperId: wrapperId,
				id: id
			});
			filterMakesElement.addEventListener('change', () => this.updateMakeModels(wrapperId));
			this.updateMakeModels(wrapperId);
		}
		const removeElement = wrapperElement.getElementsByClassName('js-vehicles-storage__filter__form__filters__makes-models-typename__remove')[0] as HTMLElement;
		if(removeElement){
			removeElement.addEventListener('click', (e) => this.handleFilterMakesModelsTypeNameRemove(e,wrapperId));
		}
	}

	private updateModelsFromQueryIfNotSet() {
		if (this.filterMakesModelsWrapper && this.filterMakesModelsWrapper.length > 0 && this.filterMakesModelsWrapper[0].filterModelsElement.selectedIndex == 0) {
			try {
				const currentQuery = queryStringAsObject(window.location.search);
				const currentQueryModels = currentQuery ?
					(currentQuery["Models"] && currentQuery["Models"] != "" ? currentQuery["Models"] :
						currentQuery["Models%5B0%5D"] && currentQuery["Models%5B0%5D"] != "" ? currentQuery["Models%5B0%5D"] : null)
					: null;
				if (currentQueryModels) {
					const modelsFromQuery = currentQueryModels.indexOf('%') > -1 ? currentQueryModels.substring(0, currentQueryModels.indexOf('%')) :
						(currentQueryModels.indexOf(',') > -1 ? currentQueryModels.substring(0, currentQueryModels.indexOf(',')) : currentQueryModels);
					if (modelsFromQuery != "") {
						const filterModelsToSelect = this.filterMakesModelsWrapper[0].filterMakeModels.filter(o => o.prefixValue == modelsFromQuery);
						if (filterModelsToSelect && filterModelsToSelect.length > 0) {
							this.filterMakesModelsWrapper[0].filterModelsElement.value = filterModelsToSelect[0].value;
						}
					}

				}
			}
			catch { }
		}
	}

	private updateMakeModels(wrapperId: string) {
		this.filterMakesModelsWrapper.filter(o => o.wrapperId === wrapperId).forEach(makesModels => {
			if (makesModels.filterMakeModels && makesModels.filterMakeModels.length > 0) {
				if (makesModels.filterMakesElement.selectedIndex > 0) {
					const selectedMake = makesModels.filterMakesElement.options[makesModels.filterMakesElement.selectedIndex];
					const make = selectedMake.value;
					const selectedValue = makesModels.filterModelsElement.options[makesModels.filterModelsElement.selectedIndex].value;
					this.cleanFilterModels(makesModels, false);
					makesModels.filterMakeModels.map(o => this.updateMakeModel(makesModels.filterModelsElement, o, make, selectedValue));

					if (makesModels.filterModelsElement.selectedIndex > 0) {
						addClass(makesModels.filterModelsElement, 'is-filled');
					}
				}
				else {
					this.cleanFilterModels(makesModels);
				}
			}
		});
	}

	private cleanFilterModels(makesModels: MakesModels, addChooseMake: boolean = true) {
		makesModels.filterModelsElement.selectedIndex = 0;
		const lengthFilterModels = makesModels.filterModelsElement.options.length;
		for (let i = 1; i < lengthFilterModels; i++) {
			makesModels.filterModelsElement.remove(1);
		}
		if (addChooseMake) {
			const chooseMakeOption = makesModels.filterMakeModels.filter(o => o.isChooseMake);
			if (chooseMakeOption && chooseMakeOption.length > 0) {
				makesModels.filterModelsElement.add(chooseMakeOption[0].element);
			}
		}
		removeClass(makesModels.filterModelsElement, 'is-filled');
	}

	private updateMakeModel(filterModelsElement: HTMLSelectElement, makeModel: MakeModel, make: string, selectedValue: string) {
		makeModel.isVisible = makeModel.make == make;
		if (makeModel.isVisible) {
			makeModel.element.selected = selectedValue == makeModel.value;
			filterModelsElement.add(makeModel.element);
		}
	}

	private handleFilterMakesModelsTypeNameAdd(e: Event) {
		e.preventDefault();
		e.stopImmediatePropagation();
		e.stopPropagation();
		if (hasClass(this.filterMakesModelsTypeNameAdd, this.hiddenClass) == false && this.filterMakesModelsWrapper.length < this.filterMakesModelsTypeNameMaxCount) {

			if (this.filterMakesModelsTypeName) {
				const newFilterMakesModelsTypeNameElement = document.createElement('div');
				newFilterMakesModelsTypeNameElement.innerHTML = this.filterMakesModelsTypeNameTemplate.innerHTML;
				while (newFilterMakesModelsTypeNameElement.firstChild) {
					this.filterMakesModelsTypeName.appendChild(newFilterMakesModelsTypeNameElement.firstChild);
				}

				const filterMakesModelsTypeNames = Array.from(this.formElementWrapper.getElementsByClassName('js-vehicles-storage__filter__form__filters__makes-models-typename--single')) as HTMLElement[];
				if (filterMakesModelsTypeNames && filterMakesModelsTypeNames.length > 0) {
					let i = filterMakesModelsTypeNames.length - 1;
					this.initializeFilterFormMakesModelsTypeName(filterMakesModelsTypeNames[i],i);
					this.handleFilterMakesModelsTypeNameUpdated();		
				}
			}
		}
	}

	private handleFilterMakesModelsTypeNameRemove(e: Event,wrapperId: string){
		e.preventDefault();
		e.stopImmediatePropagation();
		e.stopPropagation();
		if(this.filterMakesModelsWrapper.length > 1){
			this.filterMakesModelsWrapper = this.filterMakesModelsWrapper.filter(o => o.wrapperId !== wrapperId);
			document.getElementById(wrapperId).remove();
			this.handleFilterMakesModelsTypeNameUpdated();
		}
	}

	private handleFilterMakesModelsTypeNameUpdated(){
		this.updateFilterFormMakesModelsTypeNameIndex();
		this.updateFilterFormMakesModelsTypeNameAddButton();
		this.updateFilterMakesModelsTypeName();
		$.validator.unobtrusive.parse('form');
		this.showFiltersMakesModelsTypeNameInViewPort();
	}

	private updateFilterFormMakesModelsTypeNameIndex(){
		let i = 0;
		this.filterMakesModelsWrapper.forEach(o => {
			o.id = i++;
			this.updateFilterFormMakesModelsTypeNameIdentifiers(o);
		});
	}

	private updateFilterFormMakesModelsTypeNameIdentifiers(makesModels: MakesModels, toReplace: string = 'input,textarea,select,label,span') {
		if(this.filterMakesModelsWrapper){
			const elementsToUpdateIdentifiers = makesModels.wrapperElement.querySelectorAll(toReplace);
			if(elementsToUpdateIdentifiers && elementsToUpdateIdentifiers.length > 0){
				const index = makesModels.id;
				elementsToUpdateIdentifiers.forEach(o => {
                    if (o.hasAttribute('for')) {
                        o.setAttribute(
                            'for',
                            o.getAttribute('for')
                                .replace(/\_(.+?)\_/g, '_' + index + '_')
                        );
                    }
                    if (o.hasAttribute('name')) {
                        o.setAttribute(
                            'name',
                            o.getAttribute('name')
                                .replace(/\[(.+?)\]/g, '[' + index + ']')
                        );
                    }
                    if (o.hasAttribute('id')) {
                        o.setAttribute(
                            'id',
                            o.getAttribute('id')
                                .replace(/\_(.+?)\_/g, '_' + index + '_')
                        );
                    }
				});
			}
		}
	}

	private updateFilterFormMakesModelsTypeNameAddButton(){
		toggleClass(this.filterMakesModelsTypeNameAdd,this.hiddenClass,this.filterMakesModelsWrapper.length >= this.filterMakesModelsTypeNameMaxCount);
	}

	private showFiltersMakesModelsTypeNameInViewPort(){
		if(this.filterMakesModelsTypeNameWrapper){
			const rect = this.filterMakesModelsTypeNameWrapper.getBoundingClientRect();
			const additionalHeight = this.formPageSearchContainerElement ? this.formPageSearchContainerElement.getBoundingClientRect().height : 0;
				scrollToOffset(
					rect.bottom - window.innerHeight + additionalHeight,
					linearTween,
					150,
					0
				);
		}
	}

	private updateFilterMakesModelsTypeName(){
		toggleClass(this.filterMakesModelsTypeName,'has--multiple',this.filterMakesModelsWrapper.length > 1);
	}

	private initializeFilterFormSearchContainerSticky() {
		if (this.formPageSearchContainerElement && this.formPageSearchContainerWrapperElement && this.formPageFiltersElement) {
			setInterval(() => {
				var isInViewport = function (elem) {
					var bounding = elem.getBoundingClientRect();
					return (
						bounding.top >= 0 &&
						bounding.left >= 0 &&
						(bounding.bottom + 40) <= (window.innerHeight || document.documentElement.clientHeight) &&
						bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
					);
				};

				var bottomIsOutOfViewPort = function (elem) {
					var bounding = elem.getBoundingClientRect();
					return bounding.bottom < 200;
				}
				const isContainerInViewport = isInViewport(this.formPageSearchContainerWrapperElement);

				if (isContainerInViewport || (!isContainerInViewport && bottomIsOutOfViewPort(this.formPageFiltersElement))) {
					removeClass(this.formPageSearchContainerElement, this.stickyClass);
				}
				else {
					addClass(this.formPageSearchContainerElement, this.stickyClass);
				}
			}, 10);
		}
	}

	private initializeFilterFormObservation() {
		if (this.formElement && this.formPageSearchElement && this.formPageSearchElementText && this.formPageSearchElementTextCount) {

			setInterval(() => {
				const newFormData = $(this.formElement).serialize();
				if (this.filterFormData != newFormData) {
					this.filterFormData = newFormData;
					this.updateFilterFormSearchCount();
				}
			}, 100);
		}
	}

	private updateFilterFormSearchCount() {
		fetch(this.targetGetCountResults, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'accept-language': this.language,
				// todo: why? if we change to a api controller we don't have this problem...
				'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
			},
			body: this.filterFormData,
			credentials: 'include'
		})
			.then(response => {
				const contentType = response.headers.get('content-type');
				if (contentType && contentType.includes('text/html')) {
					return response.text();
				}
			})
			.then(data => this.updateFilterFormSearchCountText(data));
	}

	private updateFilterFormSearchCountText(data: string){
		if (data && data != undefined && data.length > 0 && this.formElement && this.formPageSearchElement && this.formPageSearchElementText && this.formPageSearchElementTextCount) {
			const count = parseInt(data, 10);
			const hasResults = count > 0;
			const newCountSearch = hasResults ? this.formPageSearchElementTextCount.replace('{0}', data) : this.formPageSearchElementText;
			this.formPageSearchElement.innerText = newCountSearch;
			if (hasResults) {
				this.formPageSearchElement.removeAttribute('disabled');
				removeClass(this.formPageSearchElement, 'c-button--disabled');
			}
			else {
				this.formPageSearchElement.setAttribute('disabled', 'disabled');
				addClass(this.formPageSearchElement, 'c-button--disabled');
			}
		}
	}


	private loadPreviousPage(event: any) {
		event.preventDefault();
		let page = this.getPage();
		page = page - 1 >= 1 ? page - 1 : 1;
		this.loadPage(page);
	}

	private loadNextPage(event: any) {
		event.preventDefault();
		let page = this.getPage();
		page = page + 1;
		this.loadPage(page);
	}

	private loadJumpPage(event: any) {
		event.preventDefault();
		const element = event.target || event.currentTarget;
		const page = parseInt(
			element.getAttribute('data-value')
		);
		this.loadPage(page);
	}

	private resetFilter(event: any, loadVehicleModel: boolean = false) {
		event.preventDefault();
		this.resultsContentElement.innerHTML = "";
		this.initializeFilterFormMakesModelsTypeNameSection();
		this.handleLoadFilterContent(true, loadVehicleModel);
	}

	private getPage() {
		return parseInt(this.formPageElement.value);
	}

	private loadPage(page: number) {
		this.formPageElement.value = page.toString();
		this.handleLoadResultsFromFilterForm(false);
	}
}